import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FunnelTimeIcon from '@rsuite/icons/FunnelTime';
import ExportIcon from '@rsuite/icons/Export';
import MoreIcon from '@rsuite/icons/More';
import { Icon } from '@rsuite/icons';
import SortDownIcon from '@rsuite/icons/SortDown';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import AttachmentIcon from '@rsuite/icons/Attachment';
import CopyIcon from '@rsuite/icons/Copy';
import TrashIcon from '@rsuite/icons/Trash';
import ReviewRefuseIcon from '@rsuite/icons/ReviewRefuse';
import TagIcon from '@rsuite/icons/Tag';
import { CSVLink } from 'react-csv';

import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  useToaster,
  SelectPicker,
  IconButton,
  Table,
  ButtonToolbar,
  Whisper,
  Popover,
  Dropdown,
  Pagination
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DrawerView from './DrawerView';
import { PlacementType } from 'rsuite/esm/toaster/ToastContainer';
import { MessageType } from 'rsuite/esm/Notification/Notification';
import { mockUsers } from '@/data/mock';
import AdminIcon from '@rsuite/icons/Admin';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import EditIcon from '@rsuite/icons/Edit';
import PptxGenJS from 'pptxgenjs'; 
import Excel from 'exceljs';


interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const { Column, HeaderCell, Cell } = Table;


const ManageCatalogue = () => {

  const ipp = 'http://192.168.1.23:1337';
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // Simulating an asynchronous data fetch
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Simulating a 2-second delay
  }, []);


  // Scanning Modal function Start
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // Scanning Modal function End

  // Message start
  const [type, setType] = React.useState('success' as MessageType);
  const [placement, setPlacement] = React.useState('bottomEnd' as PlacementType);


  const toaster = useToaster();

  const Cell1 = () => {
    return (
      <Button appearance='ghost' color='cyan'>Active</Button>
    )
  }
  const Buyer = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>

      <ButtonToolbar>
        <Button appearance="subtle" active><Icon style={{ 'width': '30px', 'height': '17px', 'color': 'cadetblue' }} as={AdminIcon} />
          Shortlisted
        </Button>
      </ButtonToolbar>
    </Cell>
  );
  const Buyer1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <FormControlLabel>---</FormControlLabel>
    </Cell>
  );

  const Active = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Button
        appearance="ghost" active color='cyan'
      > Active</Button>
    </Cell>
  );
  const Catalogue = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <b>Summer Collection for 2022</b>
      <p>6 Products</p>
      <p>Generated by erpdaddy.com Monday at 2:30 PM </p>
    </Cell>
  );
  const Active1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Button
        appearance="subtle" active color='orange'
      > Draft</Button>
    </Cell>
  );


  const renderMenu1 = ({ onClose, left, top, className }, ref, rowData) => {
    const handleSelect = (eventKey, rowData) => {
      onClose();
      console.log(eventKey);


    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={1} onClick={handleDownloadPPT}>Download PPT<Icon as={SortDownIcon} /></Dropdown.Item>
          <Dropdown.Item eventKey={2}><CSVLink data={cataloguedata1} >Download Excel</CSVLink><Icon as={SortDownIcon} /></Dropdown.Item>

        </Dropdown.Menu>
      </Popover>
    );
  };
  const renderMenu = ({ onClose, left, top, className }, ref) => {
    const handleSelect = eventKey => {
      onClose();
      console.log(eventKey);
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect} >
          <Dropdown.Item ><Stack justifyContent='space-between' ><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={TagIcon} /><Stack direction='column' alignItems='flex-start'><b>Create Quotation</b><p>You can maintain a list of all quotation </p><p> generated angaist buyer</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={ReviewRefuseIcon} /><Stack direction='column' alignItems='flex-start'><b>Deactivate Catalogue Link</b><p>Link will be deactivated and you can </p><p>activate it again later</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between' spacing={10}><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={AttachmentIcon} /><Stack direction='column' alignItems='flex-start'><b>Updata Link Settings</b><p>Change settings for passsword security</p> <p>and expiry date</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={CopyIcon} /><Stack direction='column' alignItems='flex-start'><b>Create a copy of this catalogue</b><p>A copy of this catalogue will be </p><p> created with same products</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
          <Dropdown.Item ><Stack justifyContent='space-between'><Stack direction='row' alignItems='flex-start' spacing={8}><Icon as={TrashIcon} /><Stack direction='column' alignItems='flex-start'><b>Delete this catalogue</b><p>Permanantly delete this catalogue </p> <p> you cannot restore them later</p></Stack></Stack><Stack><Icon as={ArrowRightLineIcon} /></Stack></Stack></Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} className="link-group">
        <Whisper placement="auto" trigger="click" speaker={renderMenu}>
          <IconButton appearance="subtle" style={{ marginTop: '-8px' }} active icon={<MoreIcon />} />
        </Whisper>
      </Cell>
    );
  };
  const Controls = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Stack spacing={5}>
        <Button
          appearance="subtle" active
        > Active</Button>
        <Button
          appearance="subtle" active
        > Preview</Button>
        <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu1}>
          <IconButton icon={<ExportIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );
  const Controls1 = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <Stack spacing={5}>
        <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu1}>
          <IconButton icon={<EditIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );




  const [showDrawer, setShowDrawer] = useState(false);


  const AddedOn = ['All Time', 'Today', 'Yesterday', 'This week', 'Last week', 'This month', 'Last month', 'Last 3 month', 'Last 6 month'].map(
    item => ({ label: item, value: item })
  );
  const [selectedOption, setSelectedOption] = useState('Option 1');

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const [cataloguedata, setCatalogueData] = useState([]);
  const [cataloguedata1, setCatalogueData1] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [productData, setProductData] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });

  useEffect(() => {
    fetchData();
  }, [cataloguedata]);
  const fetchData = async () => {
    const response = await fetch(`${ipp}/api/catalogues?populate=*&pagination[page]=${activePage}`);
    const json = await response.json();

    const productResponse = await fetch('http://192.168.1.23:1337/api/products?populate=*');
    const productJson = await productResponse.json();
    setProductData(productJson.data);
    setPagination(productJson.meta.pagination);

    const updatedCatalogueData = json.data.map((item) => ({
      ...item,
      itemCount: item.attributes.CatalogueProduct.length,
    }));
    setCatalogueData(updatedCatalogueData);
  
  };
  const getProductDataByProductId = (productId) => {
    return productData.find((product) => product.attributes.ProductId === productId);
  };
  
  
 
  const generateAndDownloadPPT = async (rowData) => {
    const ppt = new PptxGenJS();
    const { attributes } = rowData;
  
    
    const createProductSlide = (product) => {
      const slide = ppt.addSlide();
  
      const topTextBgColor = '#228a84'; // Replace with your desired background color
      slide.addShape('rect', {
        x: 0.5, // X-coordinate for the rectangle
        y: 0, // Y-coordinate for the rectangle
        w: '50%', // Width of the rectangle (100% to cover the entire slide width)
        h: 1.2, // Height of the rectangle (adjust as needed)
        fill: topTextBgColor,
      });
  
      slide.addText(`Catalogue Name: ${attributes.catalogueName}`, { x: 1, y: 0.4, fontSize: 12, fontFace: 'Arial', color: '#ffffff' });
      slide.addText(`Buyer Company: ${attributes.BuyerCompany}`, { x: 1, y: 0.7, fontSize: 10, fontFace: 'Arial', color: '#ffffff' });
      slide.addText(`Buyer Email: ${attributes.BuyerEmail}`, { x: 1, y: 1, fontSize: 10, fontFace: 'Arial', color: '#ffffff' });
  
      if (product[26]) { // Check if the image URL exists in the product data
        try {
          const imageUrl = `${ipp}${product[26]}`; // Replace 'your_ip_address_here' with the actual IP address
          const imageOpts = {
            x: 1, // Adjust the X-coordinate as needed
            y: 1.5, // Adjust the Y-coordinate as needed
            w: 4, // Adjust the width of the image as needed
            h: 4, // Adjust the height of the image as needed
            path: imageUrl, // Use the 'path' property to specify the image URL
            type: 'link', // Use the 'link' type for external images
          };
          slide.addImage(imageOpts);
          
        } catch (error) {
          console.error('Error adding image to slide:', error);
        }
      }
      

      const verticalTableX = 6; // X-coordinate for the vertical table
      const verticalTableY = 0.2; // Y-coordinate for the vertical table
      const verticalTableLineHeight = 0.2; // Adjust this to increase/decrease space between attributes and values
  
      // Function to add a pair of attribute and value in a vertical layout
      const addVerticalPair = (attr, val, yOffset, attrBgColor, valBgColor) => {
        slide.addShape('rect', {
          x: verticalTableX - 0.1,
          y: verticalTableY + yOffset - 0.1,
          w: 2.2,
          h: verticalTableLineHeight + 0.2,
          fill: attrBgColor,
        });
        slide.addText(attr, { x: verticalTableX, y: verticalTableY + yOffset, fontSize: 8, fontFace: 'Arial', color: '#000000' });
        
        slide.addShape('rect', {
          x: verticalTableX + 1 - 0.1,
          y: verticalTableY + yOffset - 0.1,
          w: 2.2,
          h: verticalTableLineHeight + 0.2,
          fill: valBgColor,
        });
        slide.addText(val, { x: verticalTableX + 1, y: verticalTableY + yOffset, fontSize: 8, fontFace: 'Arial', color: '#000000' });
      };
  
      // Add each attribute and its corresponding value as a pair in vertical layout
      addVerticalPair('P Name:', product[0], 0, '#74c5c0','#74c5c0');
      addVerticalPair('P Code:', product[1], verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('P ID:', product[2], 2 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Category Code:', product[3], 3 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Size:', product[4], 4 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Length:', product[5], 5 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Width:', product[6], 6 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Height:', product[7], 7 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Net Wt.:', product[8], 8 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Gross Wt.:', product[9], 9 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('HSN Code:', product[10], 10 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Finish Name:', product[11], 11 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Color Name:', product[12], 12 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Selling Pr. Currency:', product[13], 13 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Selling Price Unit:', product[14], 14 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Selling Price:', product[15], 15 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('ProductCost:', product[16], 16 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Search Keyword:', product[17], 17 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('MOQ:', product[18], 18 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Product Designer:', product[19], 19 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Made By:', product[20], 20 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Category Name:', product[21], 21 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('P Type Name:', product[22], 22 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('CBM:', product[23], 23 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      addVerticalPair('Buyer Name:', product[24], 24 * verticalTableLineHeight, '#74c5c0','#74c5c0');
      addVerticalPair('Buyer Sku:', product[25], 25 * verticalTableLineHeight, '#b9dcd8','#b9dcd8');
      
      // Add other attributes and their values as pairs using addVerticalPair
  
      // Adjust the y-coordinate of the next attribute pair based on your preference
  
      // Example:
      // addVerticalPair('Category Code:', product[3], 3 * verticalTableLineHeight);
      // addVerticalPair('Size:', product[4], 4 * verticalTableLineHeight);
      // addVerticalPair('Length:', product[5], 5 * verticalTableLineHeight);
      // ...
  
      // Continue adding attribute-value pairs as needed
  
      // Add any other content or elements to the slide as required
    };
  
    rowData.attributes.CatalogueProduct.forEach((product) => {
      const productId = product.CatalogProduct;
      const matchedProduct = getProductDataByProductId(productId);
  
      if (matchedProduct) {
        const productData = [
          matchedProduct.attributes.ProductName,
          matchedProduct.attributes.ProductCode,
          matchedProduct.attributes.ProductId,
          matchedProduct.attributes.CategoryCode,
          matchedProduct.attributes.SizeUnit,
          matchedProduct.attributes.Length,
          matchedProduct.attributes.Width,
          matchedProduct.attributes.Height,
          matchedProduct.attributes.NetWeight,
          matchedProduct.attributes.GrossWeight,
          matchedProduct.attributes.HSNCode,
          matchedProduct.attributes.FinishName,
          matchedProduct.attributes.ColorName,
          matchedProduct.attributes.SellingPriceCurrency,
          matchedProduct.attributes.SellingPriceUnit,
          matchedProduct.attributes.SellingPrice,
          matchedProduct.attributes.ProductCost,
          matchedProduct.attributes.SearchKeyword,
          matchedProduct.attributes.MOQ,
          matchedProduct.attributes.ProductDesigner,
          matchedProduct.attributes.MadeBy,
          matchedProduct.attributes.CategoryName,
          matchedProduct.attributes.ProductTypeName,
          matchedProduct.attributes.cbm,
          matchedProduct.attributes.BuyerName,
          matchedProduct.attributes.BuyerSku,
          matchedProduct.attributes.CoverImage.data.attributes.url,
          
        ];
  
        createProductSlide(productData);
      }
    });
  
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };
  
  let fff = productData.map((pr)=> pr.attributes.ProductId);
 

  const handleDownloadExcel = async (rowData) => {
    // Create a new workbook and add a worksheet
    const { attributes } = rowData;

  // Create a new workbook and add a worksheet
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet('Catalogue Data');

  // Add header rows for Catalogue Name, Buyer Company, and Buyer Email
  const catalogueNameCell = worksheet.getCell('A1');
  catalogueNameCell.value = 'Catalogue Name';
  catalogueNameCell.font = { bold: true };

  const buyerCompanyCell = worksheet.getCell('A2');
  buyerCompanyCell.value = 'Buyer Company';
  buyerCompanyCell.font = { bold: true };

  const buyerEmailCell = worksheet.getCell('A3');
  buyerEmailCell.value = 'Buyer Email';
  buyerEmailCell.font = { bold: true };

  worksheet.getCell('B1').value = attributes.catalogueName;
  worksheet.getCell('B2').value = attributes.BuyerCompany;
  worksheet.getCell('B3').value = attributes.BuyerEmail;
  worksheet.addRow([]); // Empty row to separate header information from product data
  
    // Add header row for product data
    const headerRow = worksheet.addRow([
      'Product Name', 'Code', 'Image','Product ID', 'Category Code', 'Description', 'Size', 'Length', 'Width', 'Height',
      'Net Weight', 'Gross Weight', 'HSN Code', 'Selling Price Currency', 'Selling Price Unit', 'Selling Price',
      'Product Cost', 'Search Keyword', 'MOQ', 'Product Designer', 'Made By', 'Category Name', 'Product Type Name',
      'CBM', 'Finish Name', 'Color Name', 'Buyer Name', 'Buyer Sku', 'Total CBM', 'Total CFT', 'Twenty FT', 'Forty FT', 'Forty HQ'
    ]);
  
    // Apply bold font to the header row
    headerRow.eachCell(cell => {
      cell.font = { bold: true };
    });
    worksheet.columns.forEach(column => {
      let maxLength = 0;
  
      column.eachCell({ includeEmpty: true }, cell => {
        const length = cell.value ? cell.value.toString().length : 0;
        if (length > maxLength) {
          maxLength = length;
        }
      });
  
      column.width = maxLength < 12 ? 12 : maxLength; // Set a minimum width of 12 if the value is smaller
    });
  
    // Prepare the product data for Excel
    const catalogueProductData = rowData.attributes.CatalogueProduct.map((product) => {
      const productId = product.CatalogProduct;
      const matchedProduct = getProductDataByProductId(productId);
      
      
      if (matchedProduct) {
        // Prepare the image URL for the thumbnail-sized image
        const imageUrl = `${ipp}${matchedProduct.attributes.CoverImage.data.attributes.url}`;
  
        // Fetch the image data using 'node-fetch'
        return fetch(imageUrl)
          .then((response) => response.arrayBuffer())
          .then((imageData) => {
            return {
              productName: matchedProduct.attributes.ProductName,
              productCode: matchedProduct.attributes.ProductCode,
              imageData: imageData, // Image data in ArrayBuffer format
              productId: matchedProduct.attributes.ProductId,
              categoryCode: matchedProduct.attributes.CategoryCode,
              Description:matchedProduct.attributes.Description,
              SizeUnit: matchedProduct.attributes.SizeUnit,
              Length: matchedProduct.attributes.Length,
              Width:  matchedProduct.attributes.Width,
              Height: matchedProduct.attributes.Height,
              NetWeight:matchedProduct.attributes.NetWeight,
              GrossWeight:matchedProduct.attributes.GrossWeight,
              HSNCode: matchedProduct.attributes.HSNCode,
              SellingPriceCurrency:matchedProduct.attributes.SellingPriceCurrency,
              SellingPriceUnit:matchedProduct.attributes.SellingPriceUnit,
              SellingPrice:matchedProduct.attributes.SellingPrice,
              ProductCost:matchedProduct.attributes.ProductCost,
              SearchKeyword:matchedProduct.attributes.SearchKeyword,
              MOQ:matchedProduct.attributes.MOQ,
              ProductDesigner:matchedProduct.attributes.ProductDesigner,
              MadeBy:matchedProduct.attributes.MadeBy,
              CategoryName:matchedProduct.attributes.CategoryName,
              ProductTypeName: matchedProduct.attributes.ProductTypeName,
              cbm:matchedProduct.attributes.cbm,
              FinishName:matchedProduct.attributes.FinishName,
              ColorName:matchedProduct.attributes.ColorName,
              BuyerName:matchedProduct.attributes.BuyerName,
              BuyerSku: matchedProduct.attributes.BuyerSku,
              Total_CBM:matchedProduct.attributes.Total_CBM,
              Total_CFT:matchedProduct.attributes.Total_CFT,
              TwentyFT:matchedProduct.attributes.TwentyFT,
              FortyFT:matchedProduct.attributes.FortyFT,
              FortyHQ: matchedProduct.attributes.FortyHQ,
              // ... (other product attributes)
            };
          })
          .catch((error) => {
            console.error('Error fetching image:', error);
            return null;
          });
      }
      return null;
    });
  
    // Wait for all image fetches to complete
    const productDataWithImages = await Promise.all(catalogueProductData);
  
    // Add each product data as a separate row in the Excel worksheet
    productDataWithImages.forEach((product,index) => {
      if (product) {
        const rowNumber = index + 5;
        const row = worksheet.addRow([
          product.productName,
          product.productCode,
          '', // Leave an empty cell for the image
          product.productId,
          product.categoryCode,
          product.Description,
          product.SizeUnit,
          product.Length,
          product.Width,
          product.Height,
          product.NetWeight,
          product.GrossWeight,
          product.HSNCode,
          product.SellingPriceCurrency,
          product.SellingPriceUnit,
          product.SellingPrice,
          product.ProductCost,
          product.SearchKeyword,
          product.MOQ,
          product.MadeBy,
          product.CategoryName,
          product.ProductTypeName,
          product.cbm,
          product.FinishName,
          product.ColorName,
          product.BuyerName,
          product.BuyerSku,
          product.Total_CBM,
          product.Total_CFT,
          product.TwentyFT,
          product.FortyFT,
          product.FortyHQ,

          // ... (other product attributes)
        ]);
  
        
  
        // Add the image as a drawing to the worksheet
        const imageId = workbook.addImage({
          buffer: product.imageData,
          extension: 'jpeg',
        });
  
        // Set the position and dimensions of the image
        const imageCell = worksheet.getCell(`B${rowNumber}`); // F column contains the images (6th column)
    worksheet.addImage(imageId, {
      tl: { col: imageCell.col, row: imageCell.row }, // Use the same row as the product data
      br: { col: imageCell.col + 1, row: imageCell.row + 1 }, // Span the image to the next column and row
      editAs: 'oneCell', // This means the image is anchored to one cell
    });
        
        // Adjust the row height to fit the image
        worksheet.getRow(row.number).height = 100; // Adjust the height as needed
      }
    });
  
    // Write the Excel file
    workbook.xlsx.writeBuffer()
      .then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Catalogue.xlsx';
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error saving Excel file:', error);
      });
  };
  

  // const getProductNames = (ProductId) => {
  //   const productNames = ProductId.map((productId) => {
  //     const product = productData.find((product) => product.attributes.ProductId === productId.CatalogProduct);
  //     return product ? product.attributes.ProductName : '';
      
  //   });
  //   return productNames.join(', ');
   
  // };
  

  // const handleDownloadPPT = (rowData) => {
  //   setSelectedRowData(rowData);
  //   // Implement the logic to generate and download the PPT file
  //   generateAndDownloadPPT(rowData);
  // };
  // const generateAndDownloadPPT = (rowData) => {
  //   const ppt = new PptxGenJS();
  //   const slide = ppt.addSlide();

  //   const catalogueProductData = rowData.attributes.CatalogueProduct.map(
  //     (product) => `Products: ${product.CatalogProduct}, Code: ${product.CatalogCode}`
  //   );

  //   // Placeholder code to generate the PPT content
  //   // Replace with your own implementation to create the desired slide content
  //   const { attributes } = rowData;
  //   slide.addText(`Catalogue Name: ${attributes.catalogueName}`, { x: 1, y: 1, fontSize: 20 });
  //   slide.addText(`Buyer Company: ${attributes.BuyerCompany}`, { x: 1, y: 2, fontSize: 16 });
  //   slide.addText(`Buyer Email: ${attributes.BuyerEmail}`, { x: 1, y: 3, fontSize: 16 });
  //   slide.addText(`${catalogueProductData.join('\n')}`, { x: 1, y: 4, fontSize: 16 });

  //   ppt.writeFile({ fileName: 'row_data.pptx' });
  // };
  


  const [buyeerdata, setBuyeerdata] = React.useState([]);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ipp}/api/buyer-details`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyercode,
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [userdata, setUserdata] = React.useState([]);
  useEffect(() => {
    fetchData4();
  }, []);
  const fetchData4 = async () => {
    try {
      const response = await fetch(`${ipp}/api/user-details`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.Full_Name,
        value: item.attributes.Company_Name,
      }));
      setUserdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (value) => {

    setSearchQuery(value);
  };
  const [activePage, setActivePage] = React.useState(1);

  

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">All Catalogues</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>All Catalogues</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10} >
              <Stack direction='column' alignItems='flex-start' >
                <label>Buyer</label>
                <SelectPicker data={buyeerdata} size="xs" appearance="default" placeholder="Buyer" style={{ width: 200 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>User</label>
                <SelectPicker data={userdata} size="xs" appearance="default" placeholder="User" style={{ width: 200 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>Status</label>
                <SelectPicker value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'All Catalogues (966)', value: 'Option 1' },
                    { label: 'Draft (183)', value: 'Option 2' },
                    { label: 'Active (755)', value: 'Option 3' },
                    { label: 'Inactive (28)', value: 'Option 4' }
                  ]} size="xs" appearance="default" placeholder="Status" style={{ width: 150 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start'>
                <label>Created On</label>
                <SelectPicker data={AddedOn} size="xs" defaultValue='All Time' appearance="default" placeholder="Updated On" style={{ width: 150 }} />
              </Stack>
              
            </Stack>
          </Stack>


          <Stack direction='column' alignItems='flex-end' spacing={44}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" type="text" value={searchQuery} onChange={handleSearch} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack >
              <Stack direction='column' alignItems='flex-start'>
                <label>Sort</label>
                <IconButton icon={<FunnelTimeIcon />} active placement="right" >
                  Recently Created
                </IconButton>

              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Divider className='divide' />
        <div className="row">
          <Panel>
            {meta123 && (
              <b style={{ marginLeft: '6px' }}>Total Catalogue: {meta123.pagination.total}</b>
            )}
            {selectedOption === 'Option 1' && (
              <>
              <Table height={420}
                data={cataloguedata.filter(item => {
                  const productName = item.attributes.catalogueName.toLowerCase();
                  const aliasCode = item.attributes.BuyerCompany.toLowerCase();
                  const ContNo = item.attributes.CatalogueCode.toLowerCase();
                  return productName.includes(searchQuery.toLowerCase()) || aliasCode.includes(searchQuery.toLowerCase()) || ContNo.includes(searchQuery.toLowerCase());
                })}

                loading={loading}
                bordered
                
                >

                <Table.Column width={80} align="center" fixed>
                  <HeaderCell><b>Sr. No.</b></HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>

                <Column width={250} align="center" sortable>
                  <HeaderCell><b>Catalogue Name</b></HeaderCell>
                  <Cell dataKey={"attributes.catalogueName"} />
                </Column>
                <Column width={100}>
                  <HeaderCell><b>Products</b></HeaderCell>
                  <Cell dataKey="itemCount" />
                </Column>

                <Column width={250}>
                  <HeaderCell><b>Status</b></HeaderCell>
                  <Active dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell><b>Buyer Company</b></HeaderCell>
                  <Cell dataKey={"attributes.BuyerCompany"} />
                </Column>


                <Column width={250}>
                  <HeaderCell><b>Buyer Activity</b></HeaderCell>
                  <Buyer dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>


                <Column width={200}>
                  <HeaderCell><b>Controls</b></HeaderCell>
                  <Cell style={{ padding: '6px' }}>
                    {rowData => (
                      <>
                        <Button
          appearance="subtle"
          active
          style={{ marginRight: '10px' }}
          onClick={() => handleDownloadExcel(rowData)}
        >
          Excel
        </Button>
                        <Button appearance="subtle" active onClick={() => generateAndDownloadPPT(rowData)}>
                          PPT
                        </Button>
                      </>
                    )}
                  </Cell>
                </Column>

                {/* <Column width={50}>
                  <HeaderCell>
                  </HeaderCell>
                  <ActionCell dataKey="id" rowData={undefined} />
                </Column> */}

              </Table>
              <Stack justifyContent='flex-end'>
              {pagination.pageCount > 1 && (
              <Pagination
              prev
              last
              next
              first
              size="xs"
              total={pagination.total}
  limit={pagination.pageSize}
  activePage={pagination.page}
              onChangePage={setActivePage}
            />
              )}
            </Stack>
</>

            )}
            

            {selectedOption === 'Option 2' && (
              <Table height={420}
                data={[]}
                loading={loading} id="table">

                <Column width={400} align="center" sortable>
                  <HeaderCell>Catalogue Details</HeaderCell>
                  <Catalogue dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell>Status</HeaderCell>
                  <Active1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell>Buyer Details</HeaderCell>
                  <Cell dataKey="name" />
                </Column>

                <Column width={250}>
                  <HeaderCell>Buyer Activity</HeaderCell>
                  <Buyer1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>


                <Column width={200}>
                  <HeaderCell>Controls</HeaderCell>
                  <Controls1 dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={50}>
                  <HeaderCell>

                  </HeaderCell>
                  <ActionCell dataKey="id" rowData={undefined} />
                </Column>

              </Table>
            )}
            {selectedOption === 'Option 3' && (
              <Table height={420}
                data={[]}

                loading={loading}>

                <Table.Column width={80} align="center" fixed>
                  <Table.HeaderCell><b>ID</b></Table.HeaderCell>
                  <Table.Cell dataKey="id" />
                </Table.Column>

                <Column width={250} align="center" sortable>
                  <HeaderCell><b>Catalogue Details</b></HeaderCell>
                  <Cell dataKey={"attributes.catalogueName"} />
                </Column>
                <Column width={100}>
                  <HeaderCell><b>Products</b></HeaderCell>
                  <Cell dataKey="itemCount" />
                </Column>

                <Column width={250}>
                  <HeaderCell><b>Status</b></HeaderCell>
                  <Active dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell><b>Buyer Company</b></HeaderCell>
                  <Cell dataKey={"attributes.BuyerCompany"} />
                </Column>


                <Column width={250}>
                  <HeaderCell><b>Buyer Activity</b></HeaderCell>
                  <Buyer dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>


                <Column width={200}>
                  <HeaderCell><b>Controls</b></HeaderCell>
                  <Controls dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={50}>
                  <HeaderCell>
                  </HeaderCell>
                  <ActionCell dataKey="id" rowData={undefined} />
                </Column>

              </Table>
            )}
            {selectedOption === 'Option 4' && (
              <Table height={420}
                data={[]}

                loading={loading}>

                <Table.Column width={80} align="center" fixed>
                  <Table.HeaderCell><b>ID</b></Table.HeaderCell>
                  <Table.Cell dataKey="id" />
                </Table.Column>

                <Column width={250} align="center" sortable>
                  <HeaderCell><b>Catalogue Details</b></HeaderCell>
                  <Cell dataKey={"attributes.catalogueName"} />
                </Column>
                <Column width={100}>
                  <HeaderCell><b>Products</b></HeaderCell>
                  <Cell dataKey="itemCount" />
                </Column>

                <Column width={250}>
                  <HeaderCell><b>Status</b></HeaderCell>
                  <Active dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={250}>
                  <HeaderCell><b>Buyer Company</b></HeaderCell>
                  <Cell dataKey={"attributes.BuyerCompany"} />
                </Column>


                <Column width={250}>
                  <HeaderCell><b>Buyer Activity</b></HeaderCell>
                  <Buyer dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>


                <Column width={200}>
                  <HeaderCell><b>Controls</b></HeaderCell>
                  <Controls dataKey="id" expandedRowKeys={undefined} onChange={undefined} rowData={undefined} />
                </Column>

                <Column width={50}>
                  <HeaderCell>
                  </HeaderCell>
                  <ActionCell dataKey="id" rowData={undefined} />
                </Column>

              </Table>
            )}



          </Panel>
        </div>

        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
        <DrawerView open={showDrawer} onClose={() => setShowDrawer(false)} />
      </Container>
    </>
  );
};

export default ManageCatalogue;